import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import AdminTour from "./AdminTour";

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [tourRestartToken, setTourRestartToken] = useState(0);

  const prepareForTour = useCallback((isActive) => {
    if (window.innerWidth <= 1024) {
      setSidebarOpen(isActive);
    }

    if (isActive) setSidebarCollapsed(false);
  }, []);

  const startTour = useCallback(() => {
    prepareForTour(true);
    setTourRestartToken((value) => value + 1);
  }, [prepareForTour]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!sidebarOpen) {
      document.body.classList.remove("admin-drawer-open");
      return undefined;
    }

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setSidebarOpen(false);
    };

    document.addEventListener("keydown", closeOnEscape);
    document.body.classList.add("admin-drawer-open");

    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.classList.remove("admin-drawer-open");
    };
  }, [sidebarOpen]);

  return (
    <div
      className={`admin-shell ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}
    >
      <Sidebar
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        onClose={() => setSidebarOpen(false)}
        onToggleCollapse={() => setSidebarCollapsed((value) => !value)}
      />

      <button
        type="button"
        className={`sidebar-backdrop ${sidebarOpen ? "visible" : ""}`}
        aria-label="Close navigation menu"
        aria-hidden={!sidebarOpen}
        tabIndex={sidebarOpen ? 0 : -1}
        onClick={() => setSidebarOpen(false)}
      />

      <div className="admin-main">
        <Navbar
          sidebarOpen={sidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
          onMenuClick={() => setSidebarOpen((value) => !value)}
          onCollapseClick={() => setSidebarCollapsed((value) => !value)}
          onStartTour={startTour}
        />

        <main className="admin-content">
          {children}
        </main>
      </div>

      <AdminTour
        restartToken={tourRestartToken}
        onActiveChange={prepareForTour}
      />
    </div>
  );
};

export default AdminLayout;
